import { recordInputAlias as recordInputAliasOp } from '@gql/operations'
import { getLogger, type GqlExecutor } from '@hopdrive/sdk-core'
import { normalizeInputForAlias } from '../../utils/normalize'

export interface RecordInputAliasParams {
  locationId: number
  customerId: number
  input: string
  executor?: GqlExecutor
}

/**
 * Record an input string as an alias for a location.
 * Fire-and-forget - errors are logged but not thrown.
 *
 * @see location-matching-algorithm.md#record-input-alias-async
 */
export async function recordInputAlias(params: RecordInputAliasParams): Promise<void> {
  const normalizedInput = normalizeInputForAlias(params.input)

  try {
    await recordInputAliasOp(
      {
        locationId: params.locationId,
        customerId: params.customerId,
        inputAlias: normalizedInput,
      },
      { executor: params.executor }
    )
  } catch (err) {
    const error = err as Error & { extensions?: { code?: string } }
    if (error?.extensions?.code !== 'constraint-violation') {
      getLogger().warn('recordInputAlias.failed', {
        locationId: params.locationId,
        error: error.message,
      })
    }
  }
}

/**
 * Fire-and-forget version that doesn't await.
 */
export function recordInputAliasAsync(params: RecordInputAliasParams): void {
  recordInputAlias(params).catch(() => {})
}
